import { render, staticRenderFns } from "./NoDataView.vue?vue&type=template&id=c7860cb4&"
import script from "./NoDataView.vue?vue&type=script&lang=js&"
export * from "./NoDataView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports